import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { configuration } from 'src/environments/environment';
import { Measures } from 'src/app/models/Measures';
import { ICQMSMasterQualifyingCodes } from 'src/app/models/ICQMSMasterQualifyingCodes';
import { CQMSCPTCodes, CQMSCriteriaMeasure } from 'src/app/models/CQMSCriteriaMeasure';
import { ICQMSMeasureQualifyingCodes } from 'src/app/models/ICQMSMeasureQualifyingCodes';
import { CQMSMedication } from 'src/app/models/CQMSMedication';
import { CQMSMeasureTotalDetails } from 'src/app/models/CQMSMeasureTotalDetails';
import { CQMSDailyDosageCriteria } from 'src/app/models/CQMSDailyDosageCriteria';
import { ICQMSMonths } from 'src/app/models/ICQMSMonths';
import { measureQualifyName } from 'src/app/models/measureQualifyName';
import { CQMSVisitNoteFlag } from 'src/app/models/CQMSVisitNoteFlag';
import { ICptOrdersComponent } from 'src/app/models/ICptOrdersComponent';
import { ICqmsVisitNoteDetails } from 'src/app/models/ICqmsVisitNoteDetails';
import { CQMSDashBoard } from 'src/app/models/CQMSDashBoard';
import { CQMSDashBoardCalcDispaly, MainAllCQMSDashBoard, MainCQMSDashBoardList } from 'src/app/models/CQMSDashBoardCalcDisplay';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { ICQMSProviderConfiguration, MeasuresProviders } from 'src/app/models/IOrdersFacilityProvider';
@Injectable({
  providedIn: 'root'
})
export class CQMSConfigurationService {
  public stringSubject = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  //insert the Measure Name
  InsertMeasureName(measureObj: Measures): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/MeasureName'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, measureObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //update Measure Name
  UpdateMeasureName(measureObj: Measures): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/MeasureName'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, measureObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // delete Measure Name
  DeleteMeasureName(measureId: number): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/delMeasureName'}?measuresId=${measureId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // get all Measure Name
  GetAllMeasuresNames(): Observable<Measures[]> {
    return this.http.get<Measures[]>(`${configuration.apiUrl + 'Master/MeasureName'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // get all Measure Name
  GetAllCQMSDashBoard(startDate: Date, endDate: Date, provideId: string, locationId: string, MeasureID: string, isqrda1: string, patid: number): Observable<MainAllCQMSDashBoard> {
    //  return this.http.get<CQMSDashBoardCalcDispaly[]>(`${configuration.clinicapiUrl + 'Encounter/CQMSDashBoard'}?startdate=${startDate}&&endDate=${endDate}&&doctorId=${provideId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`);

    const posteddata = {
      inputdata: JSON.stringify({
        startdate: startDate,
        endDate: endDate,
        provideId: provideId,
        measureId: MeasureID,
        userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
        facilityId: sessionStorage.getItem("FacilityId"),
        locationId: Number(locationId),
        type: Number(isqrda1 == "3" ? 3 : 1),
        PatID: patid,
      })
    };
    //return this.http.post<MainAllCQMSDashBoard>(`${configuration.clinicapiUrl + 'Encounter/AllCQMSDashBoard'}?startdate=${startDate}&&endDate=${endDate}&&provideId=${provideId}&&measureId=${MeasureID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}&&locationId=${Number(locationId)}`);
    return this.http.post<MainAllCQMSDashBoard>(`${configuration.clinicapiUrl + 'Encounter/AllCQMSDashBoard'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });


  }


  //insert the Criteria Details
  InsertCriteriaDetails(criteriaObj: CQMSCriteriaMeasure): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/CriteriaMeasure'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`, criteriaObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  InsertUpdateMasterQualifyingCodes(procedureFeeInfo: ICQMSMasterQualifyingCodes): Observable<ICQMSMasterQualifyingCodes> {
    return this.http.post<ICQMSMasterQualifyingCodes>(`${configuration.apiUrl + 'Master/CQMSMasterQualifyingCodes'}`, procedureFeeInfo, {
      // headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetAllMasterQualifyingCodes(): Observable<ICQMSMasterQualifyingCodes[]> {
    return this.http.get<ICQMSMasterQualifyingCodes[]>(`${configuration.apiUrl + 'Master/CQMSMasterQualifyingCodes'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  DeleteQualifyingCode(qualifyingMasterId: number): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/DelCQMSMasterQualifyingCodes'}?masterQualifyingId=${qualifyingMasterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  InsertUpdateMeasureQualifyingCodes(procedureFeeInfo: ICQMSMeasureQualifyingCodes): Observable<ICQMSMeasureQualifyingCodes> {
    return this.http.post<ICQMSMeasureQualifyingCodes>(`${configuration.apiUrl + 'Master/CQMSMeasureQualifyingCodes'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, procedureFeeInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetAllMeasureQualifyingCodes(measureId: number): Observable<ICQMSMeasureQualifyingCodes[]> {
    return this.http.get<ICQMSMeasureQualifyingCodes[]>(`${configuration.apiUrl + 'Master/CQMSMeasureQualifyingCodes'}?measureId=${measureId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  DeleteMeasureQualifyingCodes(masterQualifyingMasterId: number): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/CQMSMeasureQualifyingCodes'}?measureQualifyingId=${masterQualifyingMasterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //insert the Measure Medication
  InsertMeasureMedication(medicationObj: CQMSMedication): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/MeasureMedication'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&processtype=I`, medicationObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //update Measure Medication
  UpdateMeasureMedication(medicationObj: CQMSMedication): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/MeasureMedication'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&processtype=U`, medicationObj, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // get all Measure Name
  GetAllMeasureMedication(advanceCareplanId: number): Observable<CQMSMedication[]> {
    return this.http.get<CQMSMedication[]>(`${configuration.apiUrl + 'Master/MeasureMedication'}?measuresId=${advanceCareplanId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // get criteria
  GetMeasureCriteria(): Observable<CQMSCriteriaMeasure[]> {
    return this.http.get<CQMSCriteriaMeasure[]>(`${configuration.apiUrl + 'Master/MeasureCriteria'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // Delete Measure Name
  DeleteMeasureNameCodes(measureCodegMasterId: number): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/CQMSMasterMeasureCodes'}?masterMeasureId=${measureCodegMasterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }



  //Total MeasureDetails
  GetTotalMeasuresInfo(showActiveStatusMeasure: boolean): Observable<CQMSMeasureTotalDetails[]> {
    const posteddata = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      showActiveStatusMeasure: showActiveStatusMeasure,
      facilityId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<CQMSMeasureTotalDetails[]>(`${configuration.apiUrl + 'Master/MeasureDetails'}`, posteddata);
  }
  //Total Daily Dose Criteria
  GetDailyDoseCriteria(): Observable<CQMSDailyDosageCriteria[]> {
    return this.http.get<CQMSDailyDosageCriteria[]>(`${configuration.apiUrl + 'Master/DailyDoseCriteriaMeasure'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  //Total Days Supply Criteria
  GetDaysSupplyCriteria(): Observable<CQMSDailyDosageCriteria[]> {
    return this.http.get<CQMSDailyDosageCriteria[]>(`${configuration.apiUrl + 'Master/DaysSupplyCriteriaMeasure'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  // get all Months
  GetAllMonths(): Observable<ICQMSMonths[]> {
    return this.http.get<ICQMSMonths[]>(`${configuration.apiUrl + 'Master/CQMSAllMonths'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // get all Weeks
  GetAllWeeks(): Observable<ICQMSMonths[]> {
    return this.http.get<ICQMSMonths[]>(`${configuration.apiUrl + 'Master/CQMSAllWeeks'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  GetAllMeasureQualifyNames(): Observable<measureQualifyName[]> {
    return this.http.get<measureQualifyName[]>(`${configuration.apiUrl + 'Master/MeasureQualifyCode'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`);
  }

  GetCQMSVisitFlags(patId: number, encId: string, measureId: number): Observable<CQMSVisitNoteFlag[]> {
    const postedData = {
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      patid: patId,
      encId: encId,
      measureId: measureId
    }
    return this.http.post<any[]>(
      `${configuration.apiUrl + 'Master/CQMSVisitFlag'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
    // return this.http.get<CQMSVisitNoteFlag[]>(`${configuration.apiUrl + 'Master/CQMSVisitFlag'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&patId=${patId}&&encId=${encId}&&measureId=${measureId}`);
  }
  GetAllhomeorders(): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(`${configuration.apiUrl + 'Master/EmrEncounterCptOrders'}?userid=${encodeURIComponent(sessionStorage.getItem("userId").toString())}&&locationId=${encodeURIComponent(sessionStorage.getItem("LocationId").toString())}`);
  }
  // ***** CQMS Visit Note Information ********************

  InsertUpdateCQMSVisitNoteDetails(cqmsVisitNoteInfo: ICqmsVisitNoteDetails[]): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(cqmsVisitNoteInfo)
    }
    return this.http.post<string>(`${configuration.apiUrl + 'Master/CqmsVisitNotesDetails'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  GetCQMSVisitNoteInfo(encounterId: string): Observable<ICqmsVisitNoteDetails[]> {
    return this.http.get<ICqmsVisitNoteDetails[]>(`${configuration.apiUrl + 'Master/CqmsVisitNotesDetails'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encounterId=${encounterId}`);
  }

  // ***** CQMS Failing Encounters ********************
  GetCQMSFailingEncountersByPatientsId(patId: number, measureId: number): Observable<IEncounterData[]> {
    return this.http.get<IEncounterData[]>(`${configuration.apiUrl + 'Master/CQMSFailingEncounters'}?patId=${patId}&&measureId=${measureId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // get all Measure Name
  GetAllOrderStatusDateWise(startDate: string, endDate: string, multiSelectLocations: any): Observable<ICptOrdersComponent[]> {
    return this.http.get<ICptOrdersComponent[]>(`${configuration.apiUrl + 'Master/OrderTrackerStatusDateWise'}?startdate=${startDate}&&endDate=${endDate}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&multiSelectLocations=${multiSelectLocations}`);
  }

  // Delete In Active Measure Name
  DeleteInActiveMeasureName(measureCodegMasterId: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Master/CQMInActiveSMasterMeasure'}?masterMeasureId=${measureCodegMasterId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteMeasureMedication(measureMedicationId: number): Observable<string> {
    return this.http.put<string>(`${configuration.apiUrl + 'Master/MeasureMedicationInActive'}?measureMedId=${measureMedicationId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  //Insert CQMS Provider Configuration
  InsertCqmsProviderCongiguration(criteriaObj: ICQMSProviderConfiguration): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(criteriaObj)
    }

    return this.http.post<string>(`${configuration.apiUrl + 'Master/CQMSProviderConfiguration'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //All CQMS Provider Configuration
  GetAllProviderConfigInformation(): Observable<ICQMSProviderConfiguration[]> {
    return this.http.get<ICQMSProviderConfiguration[]>(`${configuration.apiUrl + 'Master/CQMSProviderConfiguration'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`);
  }
  // Delete CQMS Provider Configuration
  DeleteProviderConfigInformation(ConfigurationId: number): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Master/DeleteCQMSProviderConfiguration'}?ConfigurationId=${ConfigurationId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  // get all Measure Name and Providers,locations
  GetAllMeasuresProvidersLocations(): Observable<MeasuresProviders> {
    return this.http.get<MeasuresProviders>(`${configuration.apiUrl + 'Master/AllMeasuresProviders'}?FacilityId=${Number(sessionStorage.getItem("FacilityId"))}&&UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  // Generate Xml and Html file
  GetXmlHtmlInformation1(provideId: string, MeasureID: string, locationId: string, year: string, type: string): Observable<MainAllCQMSDashBoard> {
    return this.http.post<MainAllCQMSDashBoard>(`${configuration.clinicapiUrl + 'Encounter/GenerateXmlHtml'}?facilityId=${Number(sessionStorage.getItem("FacilityId"))}&&providerId=${provideId}&&measureId=${MeasureID}&&locationId=${locationId}&&year=${year}&&type=${type == '1' ? 1 : 3}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetXmlHtmlInformation(startDate: Date, endDate: Date, provideId: string, locationId: string, MeasureID: string, isqrda1: string, patId: number, fileType: string = 'xml'): Observable<string> {
    //<MainAllCQMSDashBoard>
    //  return this.http.get<CQMSDashBoardCalcDispaly[]>(`${configuration.clinicapiUrl + 'Encounter/CQMSDashBoard'}?startdate=${startDate}&&endDate=${endDate}&&doctorId=${provideId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}`);
    const posteddata = {
      inputdata: JSON.stringify({
        startdate: startDate,
        endDate: endDate,
        provideId: provideId,
        measureId: MeasureID,
        userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
        facilityId: sessionStorage.getItem("FacilityId"),
        locationId: Number(locationId),
        type: Number(isqrda1 == '1' ? 1 : 3),
        patId: patId,
        fileType: fileType
      })
    };
    //return this.http.post<MainAllCQMSDashBoard>(`${configuration.clinicapiUrl + 'Encounter/AllCQMSDashBoard'}?startdate=${startDate}&&endDate=${endDate}&&provideId=${provideId}&&measureId=${MeasureID}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${Number(sessionStorage.getItem("FacilityId"))}&&locationId=${Number(locationId)}`);
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/GenerateXmlHtml'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });


  }

  //InsertCQMSCPTCodes
  InsertCQMSCPTCodes(CPTCodeObj: CQMSCPTCodes): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(CPTCodeObj)
    };
    return this.http.post<string>(`${configuration.apiUrl + 'Master/InsertCQMSCPTCodes'}?`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // GetAllCQMSCPTCodes
  GetAllCQMSCPTCodes(MeasureId: string): Observable<CQMSCPTCodes[]> {

    return this.http.get<CQMSCPTCodes[]>(`${configuration.apiUrl + 'Master/GetAllCQMSCPTCodes'}?MeasureId=${MeasureId}&&UserId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }



  // DeleteCQMSCPTCodes
  DeleteCQMSCPTCodes(id: string): Observable<string> {
    return this.http.delete<string>(`${configuration.apiUrl + 'Master/DeleteCQMSCPTCodes'}?id=${id}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  uploadQRDAFile(file: any, providerid: string): Observable<HttpEvent<any>> {
    let formData = new FormData();
    formData.append('qrdaFile', file);
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'Encounter/ImportQRDAZIPFile'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${encodeURIComponent(sessionStorage.getItem("FacilityId")).toString()}&&LocationId=${encodeURIComponent(sessionStorage.getItem("LocationId")).toString()}&&providerid=${encodeURIComponent(providerid)}`
      , formData, {
      headers: new HttpHeaders(
        {
          'Accept': '*/*',
          // 'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*',
          // 'Authorization': 'Bearer ' + localStorage.getItem('userToken')
        })
    });
  }
  //UpdatePatientIds
  UpdateMergePatientIds(Patientids: any, mainpatientid: any): Observable<string> {
    return this.http.post<string>(`${configuration.apiUrl + 'Master/UpdateMergePatientIds'}?Patientids=${Patientids}&&mainpatientid=${mainpatientid}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
